import request from '@/utils/request';
import {getFormData} from "@/utils/helpers";

export default {
    uploadAndValidate({commit, dispatch, state}) {
        commit('START_UPLOAD');

        return request({
            method: 'post',
            url: `/delivery/products/upload-preview`,
            data: getFormData({
                file: state.file,
                establishmentAddressId: state.target.establishmentAddressId,
                brandId: state.target.brandId,
                establishmentId: state.target.establishmentId
            })
        }).then(res => {
            if (res.data) {
                commit('SET_VALIDATION_RESULTS', res.data);
            }
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, {root: true});
                commit('CANCEL_UPLOAD');
            }
        });
    },

    confirmImport({commit, dispatch, state}) {
        commit('START_IMPORT');

        return request({
            method: 'post',
            url: `/delivery/products/upload-sync`,
            data: {
                uploadId: state.validationResults.uploadId
            }
        }).then(() => {
            commit('FINISH_IMPORT');
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, {root: true});
                commit('CANCEL_IMPORT');
            }
        });
    },
};
